import React, { FC, useCallback } from 'react';
import { SendJobPost } from '../../../models/JobPostModals';
import {
  ContentBlock,
  TextBlock,
  TextSpan,
} from '../../../uicomp/atmos/content-block/ContentBlock';
import { Logo } from '../../../uicomp/atmos/logo/Logo';
import PromotedIcon from '../../../public/Promoted.svg';
import styles from './SearchComponents.module.less';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark, faLevelUpAlt } from '@fortawesome/free-solid-svg-icons';
import { faBookmark as farBookmark } from '@fortawesome/free-regular-svg-icons';
import { CheckCircleFilled } from '@ant-design/icons';
import { Grid, Space } from 'antd';
import { useConnection, useEvents, useUserInfo } from '../../../connection/Application';
import Router, { useRouter } from 'next/router';
import Utils from '../../../utils/Utils';
import Image from 'next/image';
import { useCachedData } from '../../../connection/CacheContext';

type Props = {
  value: SendJobPost;
};

export const SearchResultCard: FC<Props> = (props) => {
  const { value } = props;
  const { jobPostId } = value;
  const connection = useConnection();
  const events = useEvents();
  const user = useUserInfo();
  const router = useRouter();
  const bp = Grid.useBreakpoint();
  const cache = useCachedData();
  const save = useCallback(() => {
    if (!user) {
      localStorage.setItem(
        'BackUrl',
        `/jobs/${Utils.normalizeURIComponent(value.jobTitle ?? 'job')}/${value.jobPostId}`,
      );
      localStorage.setItem('BackQuery', JSON.stringify(router.query));
      Router.push({
        pathname: '/login',
      });
      return;
    }
    connection.post(`job-apply/${jobPostId}/save`);
    events.emit('JOB_SAVED', { jobPostId });
  }, [connection, events, jobPostId, router.query, user, value.jobPostId, value.jobTitle]);
  const unsave = useCallback(() => {
    if (!user) {
      localStorage.setItem(
        'BackUrl',
        `/jobs/${Utils.normalizeURIComponent(value.jobTitle ?? 'job')}/${value.jobPostId}`,
      );
      localStorage.setItem('BackQuery', JSON.stringify(router.query));
      Router.push({
        pathname: '/login',
      });
      return;
    }
    connection.post(`job-apply/${jobPostId}/unsave`);
    events.emit('JOB_UNSAVED', { jobPostId });
  }, [connection, events, jobPostId, router.query, user, value.jobPostId, value.jobTitle]);
  return (
    <>
      <ContentBlock
        left={<Logo src={value.recruiterImage} size={bp.md ? 'medium' : 'small'} />}
        gap={'lg'}>
        <Space
          direction={'vertical'}
          className={Utils.mergeClasses({ ['pr-[20px]']: value.featuredAdvert === 1 })}>
          <Space direction={'vertical'} size={0}>
            <TextBlock heading>{value.jobTitle}</TextBlock>
            <TextBlock>{value.recruiterName}</TextBlock>
            <TextBlock secondary>{cache.getLocationString(value.locationData ?? [])}</TextBlock>
          </Space>
          <Space size={['large', 'small']} wrap>
            <TextBlock level={-1} primary>
              {moment(value.time).fromNow()}
            </TextBlock>
            <ContentBlock
              secondary
              role={'button'}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                (value.shortlisted ? unsave : save)();
              }}
              left={
                <FontAwesomeIcon
                  icon={value.shortlisted ? faBookmark : farBookmark}
                  width={12}
                  className={value.shortlisted ? styles.saved : styles.notSaved}
                />
              }>
              {value.shortlisted ? 'Saved' : 'Save'}
            </ContentBlock>
            {value.applied && (
              <ContentBlock
                left={
                  <TextSpan primary>
                    <CheckCircleFilled />
                  </TextSpan>
                }>
                Applied on {moment(value.appliedTime).format('MMM DD yyyy')}
              </ContentBlock>
            )}
            {value.promoted && (
              <div className={styles.boostIcon}>
                <FontAwesomeIcon icon={faLevelUpAlt} width={12} />
              </div>
            )}
          </Space>
        </Space>
        {value.featuredAdvert === 1 && (
          <div className={bp.lg ? styles.featuredAdvert : styles.featuredAdvertMobile}>
            <Image alt="promoted" src={PromotedIcon} />
          </div>
        )}
      </ContentBlock>
      {/*{value.featuredAdvert === 1 && bp.lg && (*/}
      {/*  <div className={styles.featuredAdvert}>*/}
      {/*    <Image src={FeaturedIcon} />*/}
      {/*  </div>*/}
      {/*)}*/}
    </>
  );
};
